<template lang="pug">
  button.resend-verification.button.component( @click='resend' ) {{ text }}
  //- button.resend-verification.button.component( @click='resend' v-else ) Send Again
</template>


<script>
  export default {
    name: 'resend-verification.button.component',

    props: {
      user: { type: Object, required: true }
    },

    data() {
      return {
        text: this.$t('Resend Verification')
      }
    },

    methods: {
      resend() {
        const actionSettingCode = { url: 'https://app.bluefaucet.com/' }
        this.text = this.$t('Sending...')
        this.user.sendEmailVerification(actionSettingCode).then( doc => {
          this.text = 'Sent!'
          setTimeout( () => this.text = this.$t('Resend Verification'), 1200 )
        })
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .resend-verification
    background var(--bg-nav)
    border-radius 7px
    padding 12px 48px
    text-align center
    color var(--clr-light)
    transition all 320ms
    font-weight normal
    &:hover, &:focus
      color white
      box-shadow var(--shadow-box)
    &:active
      transform scale(.8)
</style>
